import { render, staticRenderFns } from "./reddialog.vue?vue&type=template&id=19a9f647&scoped=true"
import script from "./reddialog.vue?vue&type=script&lang=js"
export * from "./reddialog.vue?vue&type=script&lang=js"
import style0 from "./reddialog.vue?vue&type=style&index=0&id=19a9f647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a9f647",
  null
  
)

export default component.exports